import { render, staticRenderFns } from "./ExistTag.vue?vue&type=template&id=6ad9e8c4&"
import script from "./ExistTag.vue?vue&type=script&lang=js&"
export * from "./ExistTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad9e8c4')) {
      api.createRecord('6ad9e8c4', component.options)
    } else {
      api.reload('6ad9e8c4', component.options)
    }
    module.hot.accept("./ExistTag.vue?vue&type=template&id=6ad9e8c4&", function () {
      api.rerender('6ad9e8c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/Modals/ExistTag.vue"
export default component.exports